import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import Immutable from 'immutable';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { bindActionCreators } from 'redux';
import RecommendedFeaturedContent from './components';
import { selectCurrentLibrary } from '../../../selectors/LibrarySelector';
import FeatureContentActions from '../../../actions/FeaturedContentActions';

function mapStateToProps(state) {
  const catalogSearch = state.getIn(['search', 'catalogSearch']);
  const library = selectCurrentLibrary(state);
  return {
    featuredContent: catalogSearch.get('featuredContent', Immutable.Map()).reduce(
      (transformedFeaturedContent, contentIds, contentType) =>
        transformedFeaturedContent.set(
          contentType,
          contentIds.map(id => state.getIn(['entities', 'featuredContent', id.toString()]))
        ),
      Immutable.Map()
    ),
    results: catalogSearch.get('results').flatten(),
    libraryShortName: library.get('shortName')
  };
}

class RecommendedFeaturedContentContainer extends React.PureComponent {
  constructor(props) {
    super(props);
    this.featuredContentActions = bindActionCreators(FeatureContentActions, this.props.dispatch);
  }

  componentDidMount() {
    if (this.props.results.size > 0) {
      this.featuredContentActions.fetch(this.props.results);
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.results.size > 0 && !Immutable.is(this.props.results, prevProps.results)) {
      this.featuredContentActions.fetch(this.props.results);
    }
  }

  render() {
    return (
      <RecommendedFeaturedContent libraryShortName={this.props.libraryShortName} content={this.props.featuredContent} />
    );
  }
}

RecommendedFeaturedContentContainer.propTypes = {
  featuredContent: ImmutablePropTypes.map,
  libraryShortName: PropTypes.string,
  results: ImmutablePropTypes.list,
  dispatch: PropTypes.func
};

export default connect(mapStateToProps)(RecommendedFeaturedContentContainer);
